module.exports = __webpack_public_path__ + "img/view_hover.1651834e.svg";